import CertsModalCommentBox from './CertsModalCommentBox';

export { useCertsModalCommentErrors } from './CertsModalCommentBox';
export default CertsModalCommentBox;
